import { z } from 'zod';
const text = z.string().nullish();
const flag = z.boolean().nullish();
const count = z.number().nullish();
export const userOptionSchema = z.looseObject({
  id: z.string(),
  name: text.meta({ pii: 'name' }),
  registrationNumber: text.meta({ pii: 'document' }),
  enabled: flag,
});
export const userOptionPageSchema = z.looseObject({
  data: z.array(userOptionSchema),
  paginationToken: text,
});

// `UserGetDetailResponseModel` (contexts/userContext.tsx:46-62) e `UserGetResponseModel`
// (services/user/types/userTypes.ts). Os booleanos do Cognito podem chegar como 1/0: o yup do legado converte.
const looseFlag = z.union([z.boolean(), z.number(), z.string()]).nullish();
export const userSchema = z.looseObject({
  id: z.string(),
  sub: text,
  name: text.meta({ pii: 'name' }),
  email: text.meta({ pii: 'email' }),
  registrationNumber: text.meta({ pii: 'document' }),
  phoneNumber: text.meta({ pii: 'phone' }),
  address: text.meta({ pii: 'address' }),
  enabled: flag,
  emailVerified: looseFlag,
  sendNotifications: looseFlag,
  userStatus: text,
  userCreateDate: text,
  userLastModifiedDate: text,
});
export type User = z.output<typeof userSchema>;

/** `GetListApiResponseSuccess` com o token do Cognito; total e páginas podem faltar. */
export const userPageSchema = z.looseObject({
  data: z.array(userSchema),
  page: count,
  totalItems: count,
  totalPages: count,
  paginationToken: text,
});
export type UserPage = z.output<typeof userPageSchema>;

/** `UserCreateSuccessResponse` (contexts/userContext.tsx:66-71). */
export const userCreatedSchema = z.looseObject({
  username: z.string(),
  enabled: flag,
  userStatus: text,
});
export type UserCreated = z.output<typeof userCreatedSchema>;

/** `GroupInfo` (services/user/userGroups.ts:10-13). */
export const userGroupSchema = z.looseObject({ groupName: z.string(), id: text });
export type UserGroup = z.output<typeof userGroupSchema>;
export const userGroupPageSchema = z.looseObject({
  data: z.array(userGroupSchema),
  page: count,
  totalItems: count,
  totalPages: count,
  paginationToken: text,
});

/** Corpo de `POST /User` e `PUT /User/{id}` (services/user/index.ts:51-63). */
export type UserWrite = Record<string, unknown> & {
  readonly name: string;
  readonly email: string;
  readonly registrationNumber: string;
  readonly phoneNumber: string;
  readonly address: string;
  readonly sendNotifications: 0 | 1;
  readonly emailVerified: boolean;
};
